import { EngagementWithWorkflow } from '../../types';

export const getEngagementName = (engagement: EngagementWithWorkflow) => `${engagement.workflow.name}: #${engagement.name}`;
